import { objectsToArray } from 'functions/utilities'

export default function filterComparables(campaignComparables, source, status = ''){
  const array = objectsToArray(campaignComparables)
  const soldFilter = status === 'sold'

  return array.filter((comparable) => {
    const { comparable_source, sold } = comparable

    return (source ? comparable_source === source : true) && (status === '' || soldFilter === sold)
  })
}
